var map = {
	"./test-img-1-out.png": 7078,
	"./test-img-1.png": 3235,
	"./test-img-2-out.png": 6151,
	"./test-img-2.png": 3193,
	"./test-img-3-out.png": 8993,
	"./test-img-3.png": 5678,
	"./test-img-4-out.png": 8846,
	"./test-img-4.png": 2711,
	"./test-img-5-out.png": 424,
	"./test-img-5.png": 7851,
	"./test-img-main-out.png": 3174,
	"./test-img-main.png": 9699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7358;